<template>
  <div :class="$style.logoUploadModal">
    <Modal
      :enableMainAction="enableMainAction"
      :handleMainAction="handleUploadLogoMainAction"
      headerText="Upload a Logo"
      mainActionText="upload"
      :visible="visible"
      @updateVisibility="handleUpdateVisibilityChanged"
    >
      <div :class="$style.imageContainer">
        <UploadFile
          customUploadIcon="img/icons/image-upload.svg"
          :defaultImageUrl="getLogo"
          :fileUploaded="logoUploadCount"
          :maxSize="102400"
          :minHeight="150"
          :minWidth="150"
          types="image/jpeg, image/png"
          uploadMessage="or drag your logo here"
          @remove-file="handleRemoveLogo"
          @reset-data="handleRemoveLogo"
          @upload-file="handleUploadLogo"
        />
      </div>
      <p :class="[$style.textArea, $style.subText]">
        This will be used on Applications pages in the Admin Console and User Portal
        <ul>
          <li
            v-for="rule in imageRules"
            :key="rule"
            :class="$style.imageRuleText"
          >
            <MarkdownInline :mdTemplate="rule" />
          </li>
        </ul>
      </p>
    </Modal>
  </div>
</template>

<script>
import { MarkdownInline } from '@jumpcloud/ui-components';
import { StoreModelMap } from 'client/util/Constants';
import { mapActions, mapState } from 'vuex';
import ItemTypeConstants from 'client/util/Constants/ItemTypeConstants';
import Modal from 'client/components/Modal/Modal.vue';
import UploadFile from 'client/components/FormValidation/UploadFile.vue';

const { ItemTypeConsts } = ItemTypeConstants;
const { application } = ItemTypeConsts;
const applicationModel = StoreModelMap[application];

export const imageRules = [
  '**Maximum file size:** 100KB',
  '**Accepted file types:** PNG, or JPG',
  '**Minimum resolution:** 150px by 150px',
  'Recommended: Center-aligned image with a transparent background',
];

export default {
  name: 'LogoUploadModal',

  components: {
    MarkdownInline,
    Modal,
    UploadFile,
  },

  props: {
    handleCancel: {
      default: () => {},
      type: Function,
    },

    visible: Boolean,
  },

  data: () => ({
    enableMainAction: false,
    imageRules,
    logo: null,
    logoUploadCount: 0,
  }),

  computed: {
    ...mapState(applicationModel, ['appLogo']),

    getLogo() {
      return this.appLogo && this.appLogo.imageUrl;
    },
  },

  watch: {
    visible() {
      if (!this.visible) {
        this.enableMainAction = false;
      }
    },
  },

  methods: {
    ...mapActions(applicationModel, ['setApplicationLogo']),

    handleRemoveLogo() {
      this.enableMainAction = false;
      this.logo = null;
      this.logoUploadCount = 0;
    },

    handleUpdateVisibilityChanged(visibility) {
      if (visibility === false) {
        this.handleCancel();
      }
    },

    handleUploadLogo(logo) {
      this.enableMainAction = true;
      this.logo = logo;
    },

    handleUploadLogoMainAction() {
      this.setApplicationLogo(this.logo);
      this.handleCancel();
    },
  },
};
</script>

<style module>
.imageContainer {
  align-items: flex-start;
  display: flex;
  height: 250px;
}

.imageRuleText {
  font-size: 0.9rem;
  padding-top: 3px;
}

.textArea.textArea {
  margin-top: 30px;
  width: 100%;
}
</style>
